import {toaster} from "evergreen-ui";

export default function apiFetch(input, init) {
    const responsePromise = fetch(input, {...init, credentials: "same-origin"});

    return responsePromise.then(value => {

        const errorDescription = 'Request to ' + value.url + " returned: " + value.status + " " + value.statusText;

        // 401 is the BFF saying there is no session at all, so the only thing left to do is log in
        // again. 403 is the BFF saying this session may not do this - not owning the workspace, or
        // a Google authorisation that withheld the scope - and is left to the caller to show.
        if (value.status === 401) {
            const currentPath = window.location.hash.replace(/^#/, '') || '/';
            window.location.hash = "/login?redirect=" + encodeURIComponent(currentPath);
        }
        if (value.status >= 500) {
            console.error("Fetch error! (", value.status + ")", value);
            toaster.danger("Unable to fetch required data", {
                description: errorDescription,
                duration: 20
            });
        }

        return value;
    });

}

export function dumpErrorOnCustomer(errorDescription) {
    toaster.danger("Unable to fetch required data", {
        description: "" + errorDescription,
        duration: 20
    });
}

export function ensureStatusOk(response) {
    const errorDescription = 'Request to ' + response.url + " returned: " + response.status + " " + response.statusText;

    if (!response.ok) {
        throw new Error(errorDescription);
    }
    return response;
}